import { useState } from 'react';

import ProjectedCrossesOverview from './overview';
import ProjectedCrossQueue from './queue';
import SalesOverview from '../../sales/layouts/overview';

import './styles/view.css';

// Cruces proyecto con tabs internos (patrón ASOCEBU): Catálogo (plantillas donadora×toro),
// Venta de crías (la página de ventas, movida del sidebar) y Cola (encargos tomados/libres,
// Q-255). Cada tab es una vista autocontenida; el ítem de nav "Cruces proyecto" no cambia.
const TABS = [
    { key: 'catalog', label: 'Catálogo' },
    { key: 'sales',   label: 'Venta de crías' },
    { key: 'queue',   label: 'Cola' },
];

export default function ProjectedCrossesView() {
    const [tab, setTab] = useState('catalog');

    return (
        <div className="pcx-page">
            <div className="pcx-tabs" role="tablist" aria-label="Vistas de cruces proyecto">
                {TABS.map((t) => (
                    <button
                        key={t.key}
                        type="button"
                        role="tab"
                        aria-selected={tab === t.key}
                        className={`pcx-tab ${tab === t.key ? 'pcx-tab--active' : ''}`}
                        onClick={() => setTab(t.key)}
                    >
                        {t.label}
                    </button>
                ))}
            </div>

            {tab === 'catalog' ? <ProjectedCrossesOverview /> : tab === 'sales' ? <SalesOverview /> : <ProjectedCrossQueue />}
        </div>
    );
}
